export default [
  // ================ dashboard tier 1 ================
  {
    name: "dashmain_index",
    path: "/dashboard",
    component: () => import("../pages/homepage/Dashboard.vue"),
  },
  {
    name: "dashweb_index",
    path: "/dashboard/website",
    component: () => import("../pages/homepage/DashboardWebsite.vue"),
  },
  {
    name: "dashapp_index",
    path: "/dashboard/app",
    component: () => import("../pages/homepage/DashboardApp.vue"),
  },
  {
    name: "dashtiktok_index",
    path: "/dashboard/tiktok",
    component: () => import("../pages/homepage/DashboardTiktok.vue"),
  },
  {
    name: "dashboard_indexvita",
    path: "/dashboard-vita",
    component: () => import("../pages/homepage/DashboardVita.vue"),
  },
  {
    name: "dashboard_indexhr",
    path: "/dashboard-hr",
    component: () => import("../pages/homepage/DashboardHr.vue"),
  },
  {
    name: "dashreseller_index",
    path: "/dashboard/reseller",
    component: () => import("../pages/homepage/DashboardReseller.vue"),
  },
  {
    name: "dashboard_indexit",
    path: "/dashboard-it",
    component: () => import("../pages/homepage/DashboardIT.vue"),
  },
  {
    name: "dashboard_indexexternal",
    path: "/dashboard-external",
    component: () => import("../pages/homepage/DashboardExternal.vue"),
  },
  {
    name: "dashstore_index",
    path: "/dashboard/store",
    component: () => import("../pages/homepage/DashboardStore.vue"),
  },
  // ================ dashboard tier 2 ================ 
  {
    name: "dashweb_orders",
    path: "/dashboard/website/performance-orders",
    // component: () => import("../pages/homepage/website/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashweb_cart",
    path: "/dashboard/website/performance-cart",
    // component: () => import("../pages/homepage/website/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashweb_visit",
    path: "/dashboard/website/performance-visit",
    // component: () => import("../pages/homepage/website/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashweb_brand",
    path: "/dashboard/website/brand",
    // component: () => import("../pages/homepage/website/performanceBrand.vue"),
    component: () => import("../pages/homepage/global/performanceBrand.vue"),
  },
  {
    name: "dashweb_category",
    path: "/dashboard/website/category",
    // component: () => import("../pages/homepage/website/performanceCategory.vue"),
    component: () => import("../pages/homepage/global/performanceCategory.vue"),
  },
  {
    name: "dashweb_custperform",
    path: "/dashboard/website/customers-perform",
    // component: () => import("../pages/homepage/website/performanceMember.vue"),
    component: () => import("../pages/homepage/global/performanceMember.vue"),
  },
  {
    name: "dashweb_custnotperform",
    path: "/dashboard/website/customers-notperform",
    // component: () => import("../pages/homepage/website/performanceNonActiveMember.vue"),
    component: () => import("../pages/homepage/global/performanceNonActiveMember.vue"),
  },
  {
    name: "dashweb_promotions",
    path: "/dashboard/website/promotions",
    // component: () => import("../pages/homepage/website/voucherPromo.vue"),
    component: () => import("../pages/homepage/global/voucherPromo.vue"),
  },
  {
    name: "dashweb_payment",
    path: "/dashboard/website/payment",
    // component: () => import("../pages/homepage/website/paymentMethod.vue"),
    component: () => import("../pages/homepage/global/paymentMethod.vue"),
  },
  {
    name: "dashweb_oos",
    path: "/dashboard/website/oos",
    component: () => import("../pages/homepage/website/outOffStock.vue"),
  },
  {
    name: "dashweb_aoos",
    path: "/dashboard/website/almost-oos",
    component: () => import("../pages/homepage/website/lowStock.vue"),
  },
  {
    name: "dashweb_vipmembers",
    path: "/dashboard/website/vip-members",
    component: () => import("../pages/homepage/website/vipManagement.vue"),
  },

  // ================ dashboard tier 2 App ================ 
  {
    name: "dashapp_orders",
    path: "/dashboard/app/performance-orders",
    // component: () => import("../pages/homepage/app/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashapp_cart",
    path: "/dashboard/app/performance-cart",
    // component: () => import("../pages/homepage/app/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashapp_visit",
    path: "/dashboard/app/performance-visit",
    // component: () => import("../pages/homepage/app/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name: "dashapp_brand",
    path: "/dashboard/app/brand",
    // component: () => import("../pages/homepage/app/performanceBrand.vue"),
    component: () => import("../pages/homepage/global/performanceBrand.vue"),
  },
  {
    name: "dashapp_category",
    path: "/dashboard/app/category",
    // component: () => import("../pages/homepage/app/performanceCategory.vue"),
    component: () => import("../pages/homepage/global/performanceCategory.vue"),
  },
  {
    name: "dashapp_custperform",
    path: "/dashboard/app/customers-perform",
    // component: () => import("../pages/homepage/app/performanceMember.vue"),
    component: () => import("../pages/homepage/global/performanceMember.vue"),
  },
  {
    name: "dashapp_custnotperform",
    path: "/dashboard/app/customers-notperform",
    // component: () => import("../pages/homepage/app/performanceNonActiveMember.vue"),
    component: () => import("../pages/homepage/global/performanceNonActiveMember.vue"),
  },
  {
    name: "dashapp_promotions",
    path: "/dashboard/app/promotions",
    // component: () => import("../pages/homepage/app/voucherPromo.vue"),
    component: () => import("../pages/homepage/global/voucherPromo.vue"),
  },
  {
    name: "dashapp_payment",
    path: "/dashboard/app/payment",
    // component: () => import("../pages/homepage/app/paymentMethod.vue"),
    component: () => import("../pages/homepage/global/paymentMethod.vue"),
  },
  {
    name: "dashapp_oos",
    path: "/dashboard/app/oos",
    component: () => import("../pages/homepage/app/outOffStock.vue"),
  },
  {
    name: "dashapp_aoos",
    path: "/dashboard/app/almost-oos",
    component: () => import("../pages/homepage/app/lowStock.vue"),
  },
  {
    name: "dashapp_vipmembers",
    path: "/dashboard/app/vip-members",
    component: () => import("../pages/homepage/app/vipManagement.vue"),
  },

  // ================ dashboard tier 2 Tiktok ================ 
  {
    name: "dashtiktok_product",
    path: "/dashboard/tiktok/product",
    component: () => import("../pages/homepage/tiktok/performanceProduct.vue"),
  },
  {
    name: "dashtiktok_brand",
    path: "/dashboard/tiktok/brand",
    component: () => import("../pages/homepage/tiktok/performanceBrand.vue"),
  },
  {
    name: "dashtiktok_category",
    path: "/dashboard/tiktok/category",
    component: () => import("../pages/homepage/tiktok/performanceCategory.vue"),
  },
  {
    name: "dashtiktok_custperform",
    path: "/dashboard/tiktok/customers-perform",
    component: () => import("../pages/homepage/tiktok/performanceMember.vue"),
  },
  {
    name: "dashtiktok_custnotperform",
    path: "/dashboard/tiktok/customers-notperform",
    component: () => import("../pages/homepage/tiktok/performanceNonActiveMember.vue"),
  },
  {
    name: "dashtiktok_promotions",
    path: "/dashboard/tiktok/promotions",
    component: () => import("../pages/homepage/tiktok/voucherPromo.vue"),
  },
  {
    name: "dashtiktok_payment",
    path: "/dashboard/tiktok/payment",
    component: () => import("../pages/homepage/tiktok/paymentMethod.vue"),
  },

  // ================ dashboard tier 2 Reseller ================ 
  {
    name:"dashreseller_resellerperform",
    path:"/dashboard/reseller-perform",
    component: () => import("../pages/homepage/reseller/peformanceReseller.vue"),
  },
  {
    name:"dashreseller_resellernotperform",
    path:"/dashboard/reseller-inactive",
    component: () => import("../pages/homepage/reseller/inactiveReseller.vue"),
  },
  {
    name:"dashreseller_resellerdetail",
    path:"/dashboard/reseller/:id",
    component: () => import("../pages/homepage/reseller/peformanceResellerDetail.vue"),
  },
  {
    name:"dashreseller_product",
    path:"/dashboard/reseller-product",
    component: () => import("../pages/homepage/reseller/resellerProductPeformance.vue"),
  },
  {
    name:"dashreseller_category",
    path:"/dashboard/reseller-category",
    component: () => import("../pages/homepage/reseller/resellerCategoryPeformance.vue"),
  },
  {
    name:"dashreseller_brand",
    path:"/dashboard/reseller-brand",
    component: () => import("../pages/homepage/reseller/resellerBrandPeformance.vue"),
  },

  // ================ dashboard tier 2 Store ================ 
  {
    name:"dashstore_peformance",
    path:"/dashboard/store/peformance",
    component: () => import("../pages/homepage/store/performanceStore.vue"),
  },
  {
    name:"dashstore_product",
    path:"/dashboard/store/performance-orders",
    // component: () => import("../pages/homepage/store/performanceProduct.vue"),
    component: () => import("../pages/homepage/global/performanceProduct.vue"),
  },
  {
    name:"dashstore_brand",
    path:"/dashboard/store/brand",
    // component: () => import("../pages/homepage/store/performanceBrand.vue"),
    component: () => import("../pages/homepage/global/performanceBrand.vue"),
  },
  {
    name:"dashstore_category",
    path:"/dashboard/store/category",
    // component: () => import("../pages/homepage/store/performanceCategory.vue"),
    component: () => import("../pages/homepage/global/performanceCategory.vue"),
  },
  {
    name:"dashstore_custperform",
    path:"/dashboard/store/custperform",
    // component: () => import("../pages/homepage/store/performanceCustomer.vue"),
    component: () => import("../pages/homepage/global/performanceMember.vue"),
  },
  {
    name:"dashstore_custnotperform",
    path:"/dashboard/store/custnotperform",
    // component: () => import("../pages/homepage/store/performanceCustomerNotActive.vue"),
    component: () => import("../pages/homepage/global/performanceNonActiveMember.vue"),
  },
  {
    name:"dashstore_promotions",
    path:"/dashboard/store/promotions",
    // component: () => import("../pages/homepage/store/voucherPromo.vue"),
    component: () => import("../pages/homepage/global/voucherPromo.vue"),
  },
  {
    name:"dashstore_payment",
    path:"/dashboard/store/payment",
    // component: () => import("../pages/homepage/store/paymentMethod.vue"),
    component: () => import("../pages/homepage/global/paymentMethod.vue"),
  },
  {
    name:"dashstore_peformance_detail",
    path:"/dashboard/store/peformance/:storeCode",
    component: () => import("../pages/homepage/store/performanceStoreDetail.vue"),
  },
  // {
  //   name:"dashstore_custperform_detail",
  //   path:"/dashboard/store/custperform/:id",
  //   component: () => import("../pages/homepage/store/performanceCustomerAtStore.vue"),
  // },
];